import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
moment.locale('pt-BR');

@Pipe({
  name: 'convertAge'
})
export class ConvertAgePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return Math.floor(moment(new Date()).diff(moment(value, 'DDMMYYYY'), 'years', true));
  }

}
